<template>
  <BaseModal
    ref="modal"
    class="modal-terms"
    v-bind="attributes"
    v-on="$listeners"
  >
    <header class="modal-terms__header">
      <BaseTitle
        v-if="title"
        v-bind="title"
      />
    </header>
    <div class="modal-terms__content">
      <BaseText
        v-if="terms"
        v-bind="terms"
      />
    </div>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/BaseModal.vue';
import BaseTitle from '@/components/BaseTitle.vue';
import BaseText from '@/components/BaseText.vue';
import terms from '@/locales/terms';

export default {
  name: 'ModalTerms',
  components: {
    BaseModal,
    BaseTitle,
    BaseText,
  },
  props: {
    type: {
      type: String,
      default: '',
    },
    title: {
      type: Object,
      default: null,
    },
  },
  computed: {
    attributes() {
      return {
        actions: [
          {
            text: this.$t('actions.understand'),
            action: this.close,
            theme: 'light',
          },
        ],
        ...this.$attrs,
      };
    },
    terms() {
      const { locale } = this.$i18n;
      const text = terms[this.type];
      return {
        text: text?.[locale] || '',
      };
    },
  },
  methods: {
    close() {
      return this.$refs.modal?.close();
    },
  },
};
</script>

<style lang="stylus">
.modal-terms
  .modal__content
    width 48em
    color inherit
    background none
    padding 0
    padding-top 1em
    padding-bottom 3.5em

  .modal__close
    position sticky
    top 0
    left 100%
    margin 0
    margin-bottom -3.5em
    margin-right -4em

  &__header
    padding 1.5em 0
    text-align center

  &__content
    background-color #fff
    color $c_text
    border-radius inherit
    padding 2em 2em 3em 2em
</style>
